import React from 'react';
import { Link } from 'react-scroll';
import hero1 from '../../images/slider/profile.png';
import { useLanguage } from '../../i18n/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();
  return (
    <section className="static-hero" id="home">
      <div className="hero-grid-overlay"></div>
      <div className="container">
        <div className="hero-inner-split">
          <div className="hero-copy">
            <span className="hero-eyebrow">{t.hero.eyebrow}</span>
            <h1 className="hero-headline">
              {t.hero.headlinePart1}{' '}
              <span className="hero-headline-accent">{t.hero.headlinePart2}</span>
            </h1>
            <p className="hero-subheading">{t.hero.description}</p>
            <Link
              className="theme-btn hero-cta"
              to="contact"
              spy={true}
              smooth={true}
              duration={500}
            >
              {t.hero.cta}
            </Link>
            <div className="hero-tags">
              {(t.hero?.tags ?? []).map((tag) => (
                <span key={tag} className="hero-tag">{tag}</span>
              ))}
            </div>
          </div>

          <div className="hero-photo-wrap">
            <div className="hero-glow-blob"></div>
            <div className="hero-photo-ring">
              <img src={hero1} alt="Emmanuel Mérida" className="hero-photo-img" />
            </div>
            <div className="hero-badge">
              <span className="hero-badge-number">10+</span>
              <span className="hero-badge-label">{t.about?.yearsLabel}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
